// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".we-chat[data-v-7ba5bd90] {\n  padding-bottom: 120px;\n}", ""]);
// Exports
module.exports = exports;
